const styles = {
  container: {
    padding: "5px 5px",
    marginBottom: "16px",
    background: "rgb(70,90,238,0.2)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "98%",
  },

  formSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    padding: "10px",
    flexGrow: 1,
  },
  dayLabel: {
    fontWeight: "bold",
  },
  programList: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    width: "5%",
  },
};

export default styles;
